import { toKebabCase } from './string';
export const getCollectionSearchParam = (collectionTitle: string) => {
  const urlSearchParams = new URLSearchParams();
  urlSearchParams.append('filters', `collection:${collectionTitle}`);
  return urlSearchParams.toString();
};
export const getItemsTabName = (gameTitle: string) => {
  const GAMES_TO_ITEMS_TAB_NAME = {
    'undead blocks': 'weapons',
  };
  return GAMES_TO_ITEMS_TAB_NAME[gameTitle.toLowerCase()] || 'items';
};

export const getCollectionLink = (
  gameTitle: string,
  collectionTitle: string,
) => {
  return `/game/${toKebabCase(gameTitle)}/${getItemsTabName(
    gameTitle,
  )}/?${getCollectionSearchParam(collectionTitle)}`;
};
